import { Box, Group, Menu, Text } from '@mantine/core';
import { IconChevronRight } from '@tabler/icons-react';
import { forwardRef, ReactElement } from 'react';

export type TimelineHeaderAddMenuItemDropdown = {
  key: string;
  label: string;
  caption?: string;
  /** Shown but not clickable; say why in `caption`. */
  disabled?: boolean;
  onClick: () => void;
};

export type TimelineHeaderAddMenuItemProps = {
  icon: ReactElement;
  label: string;
  onClick?: () => void;
  dropdownItems?: TimelineHeaderAddMenuItemDropdown[];
} & React.ComponentProps<typeof Group>;

const TimelineHeaderAddMenuItem = forwardRef<HTMLDivElement, TimelineHeaderAddMenuItemProps>(
  ({ icon, label, dropdownItems, onClick, ...groupProps }, ref) => {
    if (!dropdownItems?.length) {
      return (
        <Menu.Item onClick={onClick}>
          <Group ref={ref} justify="flex-start" gap="5px" {...groupProps}>
            {icon}
            <Text flex={1}>{label}</Text>
          </Group>
        </Menu.Item>
      );
    }

    return (
      <Menu.Item>
        <Menu shadow="md" width={200} position="right-end" trigger="hover">
          <Menu.Target>
            <Group ref={ref} justify="flex-start" gap="5px" {...groupProps} onClick={(e) => e.stopPropagation()}>
              {icon}
              <Text flex={1}>{label}</Text>
              <IconChevronRight size="14px" />
            </Group>
          </Menu.Target>
          <Menu.Dropdown style={{ borderRadius: '16px' }}>
            {dropdownItems.map((item) => (
              <Menu.Item key={item.key} onClick={item.onClick} disabled={item.disabled}>
                <Box>
                  <Text>{item.label}</Text>
                  <Text size="xs" c="#64748B">
                    {item.caption}
                  </Text>
                </Box>
              </Menu.Item>
            ))}
          </Menu.Dropdown>
        </Menu>
      </Menu.Item>
    );
  }
);

export default TimelineHeaderAddMenuItem;
